export const MarketShopShadows = {
  marketShopShadow: '0 0 2rem 0 #0000001a',
}

export type MarketShopShadowsType = typeof MarketShopShadows
